import {dibApi} from "../chat/dibApi";
import classes from "./SupplierInfo.module.css";

export const SupplierInfo = ({
    resourceId,
    segmentId,
}: {
    resourceId: string;
    segmentId: string | undefined;
}) => {
    const {data: documentData} = dibApi.endpoints.getDocument.useQuery({
        resourceId,
        segmentId,
    });

    const supplier = documentData?.supplier;

    if (!supplier || supplier === "DIBkunnskap") {
        return null;
    }

    return (
        <div className={classes.infoSection}>
            <h2 className={classes.sectionHeader}>Info</h2>
            <span className={classes.supplierName}>{supplier}</span>
        </div>
    );
};
